/* eslint-disable no-undef */
/* eslint-disable prettier/prettier */
// API base is injected at build time via webpack DefinePlugin
// (production -> app.axya.co, development -> nightly.app.axya.co) so a build can
// never silently ship the wrong backend. Falls back to prod if not injected.
export const constants = {
    BASE_URL: process.env.API_BASE_URL || "https://app.axya.co",
    secretKey: "e3251447069f7b89c517b647b448e542598c0d41e76edfd0a7ad4f802e447718"
};
